import React from 'react';
import { Box, Typography, Paper, Chip } from '@mui/material';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import ErrorIcon from '@mui/icons-material/Error';

interface JiraStatusBlockProps {
  isAuthenticated: boolean;
  jiraBaseUrl?: string;
  onClick: () => void;
}

const JiraStatusBlock: React.FC<JiraStatusBlockProps> = ({ isAuthenticated, onClick }) => {
  return (
    <Paper
      elevation={1}
      sx={{
        px: 2,
        py: 1,
        cursor: 'pointer',
        transition: 'all 0.2s',
        display: 'inline-flex',
        alignItems: 'center',
        '&:hover': {
          elevation: 2,
          backgroundColor: 'action.hover',
        },
      }}
      onClick={onClick}
    >
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
        {isAuthenticated ? (
          <>
            <CheckCircleIcon color="success" sx={{ fontSize: 20 }} />
            <Box>
              <Typography variant="body2" fontWeight={500}>
                Подключено
              </Typography>
            </Box>
            <Chip
              label="Активно"
              color="success"
              size="small"
              sx={{ height: 20, fontSize: '0.7rem' }}
            />
          </>
        ) : (
          <>
            <ErrorIcon color="warning" sx={{ fontSize: 20 }} />
            <Typography variant="body2" fontWeight={500}>
              Не подключено
            </Typography>
            <Chip
              label="Не активно"
              color="warning"
              size="small"
              sx={{ height: 20, fontSize: '0.7rem' }}
            />
          </>
        )}
      </Box>
    </Paper>
  );
};

export default JiraStatusBlock;
